<div id="reference-tree-view">
  <div class="header">
    <div class="label property-name">
      {{ (validationType === 'cudConfig' || validationType === 'qvTableValidation' ? 'WARN_ERR' : 'PUBLISH_NOTIFICATION') | translate }}
    </div>
    <div>
      <!-- <button type="button" class="mr-2 err" *ngIf="generationLog.generationStatus === 'COMPILATION_FAILED'">Compilation Failed</button> -->
      <span (click)="closePopup()" (keyup.enter)="closePopup()" tabindex="0" aria-label="Close popup">
        <i class="pi pi-times-circle close-icon" style="font-size: 1.5rem"></i>
      </span>
    </div>
  </div>
  <div class="body">
    <div class="reference-info" *ngIf="validationType !== 'cudConfig' && validationType !== 'qvTableValidation'">
      <p>
        {{ 'LAST_PUBLISH_PROTOTYPE' | translate }} <span class="last-pub-name">{{ lastPublishName }}</span> at
        {{ generationLog.modifiedDate | date: 'MMM d, y, hh:mm a' }}
      </p>
      <p *ngIf="compilationFailed">
        {{ 'COMPILATION_FAIL_MSG' | translate }}
        <a href="javascript:void(0)" (click)="getCloudBuildLog()" class="prototype-link">{{
          'CLICK_HERE' | translate
        }}</a>
        {{ 'TO_VIEW_LOGS' | translate }}
      </p>
    </div>
    <p-table
      [value]="files"
      [columns]="cols"
      [scrollable]="true"
      [autoLayout]="true"
      [style]="{ minWidth: '500px' }"
      [scrollHeight]="'70vh'"
      styleClass="pre-val-tbl"
    >
      <ng-template #header let-columns>
        <tr>
          <th *ngFor="let col of columns" class="{{ col.field }}">
            {{ col.header | translate }}
          </th>
        </tr>
      </ng-template>

      <ng-template #body let-data let-columns="columns" let rowIndex="rowIndex">
        <tr>
          <td *ngFor="let col of columns; let i = index">
            <span *ngIf="col.field === 'type'" class="valid-status" [ngClass]="validationStatus[data[col.field]]">
              {{ validationStatus[data[col.field]] }}
            </span>
            <span *ngIf="col.field === 'usedIn'" class="usedIn-column">
              <span class="usd-con" *ngFor="let d of data['usedIn']; let uindex = index">
                <span [ngClass]="{ 'item-name': uindex === 0 }" [attr.title]="d.key">{{ d.key }}</span>
                <span class="item-type" *ngIf="d.type" [attr.title]="d.type">{{ d.type }}</span>
                <span class="right-arrow" *ngIf="data['usedIn'].length !== uindex + 1"></span>
              </span>
            </span>
            <span *ngIf="col.field === 'problemDesc' || col.field === 'problemSol'" class="problem-text">
              {{ data[col.field] }}
            </span>
          </td>
        </tr>
      </ng-template>
      <ng-template #emptymessage let-columns>
        <tr>
          <td [attr.colspan]="cols.length" class="no-records">
            <div class="p-2 d-flex align-items-center w-100 justify-content-center">
              <span class="status-icon">
                <i
                  *ngIf="generationLog.generationStatus !== 'PUBLISH_FAILED'"
                  class="pi pi-check-circle"
                  aria-hidden="true"
                ></i>
                <i
                  *ngIf="generationLog.generationStatus === 'PUBLISH_FAILED'"
                  class="pi pi-exclamation-circle"
                  aria-hidden="true"
                ></i>
              </span>
              <p class="ml-3" *ngIf="generationLog.generationStatus !== 'PUBLISH_FAILED'">
                {{ 'NO_REC_PREVALIDATION' | translate }}
              </p>
              <p class="ml-3" *ngIf="generationLog.generationStatus === 'PUBLISH_FAILED'">
                {{ 'GENERATION_FAILED' | translate }}
              </p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="footer">
    <button pButton pRipple class="btn cancel-btn mr-0" (click)="closePopup()" *ngIf="!isContinue">Close</button>
    <button pButton pRipple *ngIf="isContinue" class="btn btn-primary mr-0" (click)="closePopup('continue')">
      {{ 'CONTINUE' | translate }}
    </button>
  </div>
</div>

<p-dialog
  [(visible)]="showLogPopUp"
  styleClass="cloud"
  [style]="{ width: '70vw', height: '89vh', overflow: 'hidden', padding: '0px' }"
  [draggable]="false"
  [modal]="true"
  appendTo="body"
  closable="showLogPopUp"
>
  <ng-template #header>
    <div class="d-flex flex-prototype" style="flex-direction: column">
      {{ 'CLOUD_BUILD_LOGS' | translate }}
    </div>
  </ng-template>
  <div class="logs p-2">
    <div class="d-flex subLogs" *ngFor="let cloudBuildLog of logsArray; let i = index">
      <span class="log-num mr-1">{{ i + 1 }}</span>
      <p id="cloud-logs">
        {{ cloudBuildLog }}
      </p>
    </div>
  </div>
  <ng-template #footer>
    <div class="text-right update-form">
      <p-button pRipple label="{{ 'CLOSE' | translate }}" class="btn cancel-btn" (onClick)="closeLogPopup()" />
    </div>
  </ng-template>
</p-dialog>
